import { FieldValues } from "react-hook-form";
import { PlanningType } from "shared/types";

import { InitialData } from "../types";

interface PlanningValue extends FieldValues {
  chronicleFilename: string;
  end_date: Date;
  start_date: Date;
  fcr_engagement: number | "";
  mode: string;
  targetSoc: number | "" | null;
  active: boolean;
  initial_soc_restoration_power: number | "" | null;
}

const normalizeNullableNumber = (value: number | "" | null) => {
  if (value === "" || value === null) {
    return null;
  }
  return value;
};

export const extractActivePlannings = (values: FieldValues): PlanningType[] => {
  return Object.values(values).reduce<PlanningType[]>((acc, planningValue) => {
    const {
      chronicleFilename,
      end_date,
      start_date,
      fcr_engagement,
      mode,
      targetSoc,
      active,
      initial_soc_restoration_power,
    } = planningValue as PlanningValue;

    if (!active) {
      return acc;
    }

    return [
      ...acc,
      {
        chronicle_filename: chronicleFilename,
        start_date,
        end_date,
        mode,
        target_soc: normalizeNullableNumber(targetSoc),
        operator_name: "",
        overidable: false,
        fcr_engagement: normalizeNullableNumber(fcr_engagement),
        reactivity_delay: 0,
        initial_soc_restoration_power: normalizeNullableNumber(initial_soc_restoration_power),
      },
    ];
  }, []);
};

export const buildPlanningPayload = (values: FieldValues, initialData: InitialData) => {
  const sitePlannings = extractActivePlannings(values);
  return initialData.site_ids.reduce<Record<number, PlanningType[]>>((acc, siteId: number) => {
    return { ...acc, [siteId]: sitePlannings };
  }, {});
};
